<template>
<v-menu v-model="visible" offset-y left :close-on-content-click="false">
    <template v-slot:activator="{ on }">
        <v-btn class="full-width" :class="buttonClass" rounded depressed v-on="on" @click="initialiseDropdown">{{label}}</v-btn>
    </template>
    <v-list>
        <div v-if="!existingOnly" class="display-flex ma-3">
            <v-text-field  ref="group" v-model="groupName" label="Name of Group" hide-details style="flex-grow:1;"></v-text-field>
            <v-btn depressed rounded @click="newGroup" style="margin-top:14px">Go</v-btn>
        </div>
        <v-list-item v-for="(group, groupIndex) in groups" @click="select(group)" :key="groupIndex">
            <v-chip dark small :color="group.colour || '#ccc'" style="margin:0px 5px 0 -3px;width:44px;text-align:center">{{group.members || '0'}}</v-chip>
            <v-list-item-title>{{group._id | space}}</v-list-item-title>
        </v-list-item>
    </v-list>
</v-menu>  


</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import Utilities from '../helpers/Utilities'

export default {
    data() {
        return {
            groupName: '',
            visible: false,
        }
    },

    components: {
        
    },
    
    props: {
        label: {
            default: 'Select a Group',
            type: String,
        },
        groups: {
            type: Array,
        },
        existingOnly: {
            default: false,
            type: Boolean,
        },
        buttonClass: {
            type: String,
        }
    },

    computed: {
        uniqueGroupName() {
            let name
            for(var n= 1; n < 99; n++) {
                name = 'Group ' + n.toString()
                if(this.groups.findIndex(o => o.name == name) < 0)
                    break
            }
            return name
        }
    },

    methods: {
        initialiseDropdown() {
            if(!this.existingOnly) {
                this.groupName = this.uniqueGroupName
                Utilities.focus(this, 'group', true)
            }
        },
        select(group) {
            this.$emit('select', group)
            this.visible = false
        },

        newGroup() {
            this.$emit('new', this.groupName)
            this.visible = false
        }
    },

    created() {

    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// GroupDropdown.vue?bf23ee26